import React from 'react'
import { Col, Container, Row } from 'reactstrap'
import ExitCamera from './ExitCamera'
import ExitDetectionStatistics from './ExitDetectionStatistics'
import RecentExitDetections from './RecentExitDetections'

function Exit_camera_Monitor() {
  return (
     <>
     <Container fluid={true} className=''>
    <hr />

        {/* heading..................... */}
      <div className="">
        <h1 style={{ fontSize: "24px", color: "#1D67AA", fontWeight: "600" }}>
          Exit Camera Monitor
        </h1>
        <p style={{ color: "#535353", fontSize: "14px" }}>
          2025 - Week 26
        </p>
      </div>


      {/* ................Entry Camera Live Feed............. */}

       <Row>
         <Col md={8}>
        <ExitCamera />
        
        
        </Col>
        <Col>
        <ExitDetectionStatistics/>
        
        
        </Col>
      </Row> 

        {/* ................Recent Entry Detections............. */}
         
        <RecentExitDetections/>
       

           
        




       </Container>
     
     </>
  )
}

export default Exit_camera_Monitor